import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then(({data}) => setUsers(data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow mb-2">Users</div>
        <h1 className="page-title">Platform users</h1>
      </div>
      <div className="surface overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200">
            <tr><th className="px-5 py-3">Name</th><th className="px-5 py-3">Email</th><th className="px-5 py-3">Role</th><th className="px-5 py-3">Country</th><th className="px-5 py-3">Company</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {users.map(u => (
              <tr key={u.id} data-testid={`admin-user-${u.id}`}>
                <td className="px-5 py-3 font-medium">{u.full_name}</td>
                <td className="px-5 py-3" data-selectable>{u.email}</td>
                <td className="px-5 py-3 text-xs uppercase tracking-wider">{u.role}</td>
                <td className="px-5 py-3">{u.country || "—"}</td>
                <td className="px-5 py-3">{u.company_name || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
